export const normalPhrases = [
  "What animal am I most like? Describe how this species and I are similar.",
  "Do any of your friends not like me?",
  "Describe the first time we met. What was your honest first impression of me?",
  "What’s the worst thing you’ve ever had to do at work or at school? How’d you handled it?",
  "If I didn’t have my current job, what do you see me doing?",
  "What’s something I do that you hate?",
  "Describe your first real kiss. Then describe your last kiss.",
  "Describe your worst bathroom-related disaster.",
  "Have you ever been fired? If so, what for? If not, why not?",
  "What’s something you think people should appreciate more about you?",
  "What movie title describes your last relationship?",
  "What are your vices? Have they gotten better or worse over time?",
  "What’s something you miss about your last serious ex?",
  "Do you think you are happier or sadder than the average person? Why?",
  "When was the last time you thought you might die? What made you feel that way?",
  "Am I friends with anyone you can’t fully endorse? Is there anything you think I should consider about them?",
  "If you discover you’ll die today, what will be your biggest regret?",
  "Your Google history has been made public. Which search is the hardest to explain?",
  "How are we right for each other romantically? Certainly, you can think of at least one way we’re compatible.",
  "What was your most embarrassing moment that transpired in public? Let's all relive it!",
  "What’s the worst date you’ve ever been on? Tell us all the juicy deets.",
  "Have you ever done something you’re not proud of for money? (Outside of an official job.)",
  "What are you anxious about? Can we reassure you?",
  "If you had to eat one delectable part of my delicious body, what part would you choose?",
  "What’s my greatest physical asset? Don’t be shy.",
  "What’s something about your personal hygiene that you could be more rigorous about?",
  "How often do you think about your own death? How, and when, do you suspect it will happen?",
  "What’s something that’s definitely not my problem, but somehow always becomes my problem?",
  "Tell us about a time you got more wasted than was advisable.",
  "If you were to kill me, how would you do it?",
  "What’s something you’ve always done—and only realized as an adult that it was weird?",
  "What would you never, ever want my help with?",
  "How would Childhood You describe you now? Would that kid like you?",
  "If we were dying of thirst, how would we ration the last bottle of water between all of us here?",
  "Do you think you are more or less attractive than the average person? Why?",
  "What’s an offense you’ve committed that could get you fired from work?",
  "How long did it take you to get over your last ex? What did you do to get over it? Are you actually over it?",
  "If I killed somebody, would you help me cover it up?",
  "Tell us about your last breakup talk. Who said what? Anything you wish you’d said?",
  "What’s the weirdest way you’ve ever earned money? How much did you get?",
  "What’s the worst thing you’ve done in a relationship?",
  "If we were to meet for the first time today, would we become friends?",
  "Was your childhood happier than the average person’s?",
  "Have you ever dated a friend’s ex? Ever wanted to?",
  "Do you think you’re healthier, or more fit, than most people?",
  "You and I are dating. What’s going to break us up?",
  "What type of person have you always wanted to date, but never had the chance?",
  "What are your insecurities? How do they manifest in your day-to-day life?",
  "Have you ever had a pregnancy scare?",
  "Write me a new dating app bio in three sentences or less.",
  "Have you ever been in love? How do you know?",
  "Will we be friends in ten years?",
  "Is there something that’s difficult to talk about amongst any of us here? Should we clear the air right now?",
  "Of the people here, who is overdue for some kind words? Let's offer some good vibes now.",
  "How are we wrong for each other romantically?",
  "What did you get in major trouble for doing as a kid, and did you ever learn your lesson?",
  "What album title describes our relationship? What is our soundtrack?",
  "Our minds have traded bodies. What’s the first thing you’re going to do in my body?",
  "Tell us about a secret you had to keep from your loved ones.",
  "Describe me in three words.",
  "When was the last time you cried? What happened? Do you need a hug?",
  "Do you think I have a more dominant or more submissive personality? Do you have any examples?",
  "How comfortable are we with one another? What things would make us uncomfortable?",
  "Do you think I care more or less about my reputation than most people?",
  "Have you ever had a discovery about your parents now that you’ve grown up?",
  "What is your worst coping mechanism? Defense mechanism?",
  "What’s the meanest thing you’ve seen me do?",
  "Is there a limit to what you would do for the right amount of money?",
  "Do you think you’re more prone to addiction than other people? Either way, how do you know?",
  "Describe my perfect life partner. Have I been on the right track to find this person?",
  "Have you broken any bones? What happened? Did you hear the crack?",
  "What’s a time when you let a problem go on for too long before you addressed it?",
  "When was the last time you spoke to an ex? What was it about? Was there any tension?",
  "If I were a chain restaurant, which one would I be and why?",
  "Have you ever talked about me behind my back? If yes, what did you say?",
  "If someone offered you $10,000 to never talk to me again, would you?",
  "Someone who’s never met me asks you what I’m like. How do you answer?",
  "What’s something you think people should never joke about?",
  "Tell us about the one that got away.",
  "When was the last time you lost your cool? What happened? How do you feel about it now?",
  "What’s something you’re still self-conscious about? Are you working on it?",
  "If you found out I’d been embezzling from work, would you rat me out?",
  "Assuming you were single, what would it take for you to get back together with your last ex?",
  "Have I ever told you a secret that you’ve let slip to a third party?",
  "Describe a time when you really disappointed someone. Did you ever earn back their trust?",
  "Who’s the smartest person here? Give us examples.",
  "Describe a way I’ve impacted your life—but may not know about it.",
  "What’s a grand gesture you tried to save or repair a relationship?",
  "What is something you’re struggling with that we don’t know about?",
  "If I listed you as my job reference, what would you say about me? Would it all be true?",
  "Tell us about a time you lied to your parents. Did they ever find out?",
  "Tell us about a time you were shot down romantically.",
  "Have you ever caught me in a lie? Did you confront me about it? Why or why not?",
  "Tell us about a time you shot someone down romantically.",
  "Help me with my ten-year plan. Describe my ideal job, income, relationship status, and attitude ten years from now.",
  "What’s your most expensive mistake?",
  "Do you have any scars you want to show us? Pick one and tell us the story behind how you got it.",
  "When was the last time you lied to me? What was the lie?",
  "How many kids are too many kids? How many will you have?",
  "Of the people here, who do you think makes the most money? What makes you think so?",
  "What would we do on our first date? (If asking partners or exes: What did you do on your first date?)",
  "Have you ever pooped yourself as an adult?",
];
